import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Dropdown/dropdown';
import { DropdownContext } from './dropdownConstants';
import { DropdownWithContext } from './DropdownWithContext';
export var Dropdown = function Dropdown(_a) {
  var _onSelect = _a.onSelect,
      ref = _a.ref,
      props = __rest(_a, ["onSelect", "ref"]);

  return React.createElement(DropdownContext.Provider, {
    value: {
      onSelect: function onSelect(event) {
        return _onSelect && _onSelect(event);
      },
      toggleTextClass: styles.dropdownToggleText,
      toggleIconClass: styles.dropdownToggleImage,
      toggleIndicatorClass: styles.dropdownToggleIcon,
      menuClass: styles.dropdownMenu,
      itemClass: styles.dropdownMenuItem,
      toggleClass: styles.dropdownToggle,
      baseClass: styles.dropdown,
      baseComponent: 'div',
      sectionClass: styles.dropdownGroup,
      sectionTitleClass: styles.dropdownGroupTitle,
      sectionComponent: 'section',
      disabledClass: styles.modifiers.disabled,
      plainTextClass: styles.modifiers.text
    }
  }, React.createElement(DropdownWithContext, Object.assign({}, props)));
};